export const validateYealinkImportFile = (keys: string[]) => {
    let result: string = "";
    
    if (!keys.includes('display_name')) {
        result += "\r\nフィールド「display_name」が不足しています。";
    }
    if (!keys.includes('office_number')) {
        result += "\r\nフィールド「office_number」が不足しています。";
    }
    if (!keys.includes('mobile_number')) {
        result += "\r\nフィールド「mobile_number」が不足しています。";
    }
    if (!keys.includes('other_number')) {
        result += "\r\nフィールド「other_number」が不足しています。";
    }
    return result
}